import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { IRemotePowerDetails } from 'app/interfaces/IRemotePowerDetails';
import { RemotePowerService } from 'app/_services/remote-power.service';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-remote-power-details',
    templateUrl: './remote-power-details.component.html',
    styleUrls: ['./remote-power-details.component.css'],
    providers: [RemotePowerService],
    standalone: false
})
export class RemotePowerDetailsComponent implements OnInit, OnChanges {
  @Input() detailsData: any;
  @Output() analyseEmmiter: EventEmitter<any> = new EventEmitter<any>()
  @Output() analyseErrorEmiter: EventEmitter<any> = new EventEmitter<any>()

  sumConsumption = 0;
  isLoading = false;
  progressValue = 0;

  shareCheapestSystemMAX = 0;
  shareCheapetHeat4ConsumerMAX = 0;
  shareLowestCo2EmissionsMAX = 0;
  shareMinConsumtionBasicEnergyMAX = 0;
  shareMaxOVEShareMAX = 0;

  remotePowerDetailsForm = this.formBuilder.group({

    isShareCheapestSystem: false,
    isShareCheapetHeat4Consumer: false,
    isShareLowestCo2Emissions: false,
    isShareMinConsumtionBasicEnergy: false,
    isShareMaxOVEShare: false,


    shareCheapestSystem: [0, [Validators.min(0), Validators.max(100)]],
    shareCheapetHeat4Consumer: [0, [Validators.min(0), Validators.max(100)]],
    shareLowestCo2Emissions: [0, [Validators.min(0), Validators.max(100)]],
    shareMinConsumtionBasicEnergy: [0, [Validators.min(0), Validators.max(100)]],
    shareMaxOVEShare: [0, [Validators.min(0), Validators.max(100)]],

  });

  showRemotePowerDialog = false;
  selected = false;
  techOptions: Array<{ id: number, ime_tehnologije: string }> = null;
  criteriaOption: Array<{ id: number, ime_kriterija: string }> = [
    { id: 1, ime_kriterija: 'Najcenejši sistem - investicija [€]' },
    { id: 2, ime_kriterija: 'Najcenejša toplota za odjemalce [€/kWh]' },
    { id: 3, ime_kriterija: 'Najmanjše emisije CO2 [kg/leto]' },
    { id: 4, ime_kriterija: 'Najmanjša raba primarne energije [kWh/leto]' },
    { id: 5, ime_kriterija: 'Največji delež OVE [%]' },
  ];
  analyseOptions: Array<{ id: number, disabled: boolean, ime_analize: string }> = [
    { id: null, disabled: true, ime_analize: 'Izberi' },
    { id: 1, disabled: false, ime_analize: 'Izbrana tehnologija' },
    { id: 2, disabled: false, ime_analize: 'Najboljša možnost glede na izbran kriterij' },
    { id: 3, disabled: false, ime_analize: 'Več-parametrična analiza odločanja glede na izbrane kriterije' }
  ];
  selectedTechOption: { id: number, ime_tehnologije: string };
  selectedTechOptionId: number = 1;
  selectedCriteriaOption: { id: number, ime_kriterija: string };
  selectedCriteriaOptionId: number = 1;
  selectedAnalyse: { id: number, disabled: boolean, ime_analize: string };
  selectedExtend: string;


  constructor(
    private formBuilder: FormBuilder,
    private remotePowerService: RemotePowerService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.remotePowerDetailsForm.valueChanges.subscribe(changes => {
      this.sumConsumption = this.calcSumConsumption(changes);
      this.maxConsumtionLogic();
    })
    this.remotePowerService.getRemotePowerDetialsTechOptions().subscribe(options => {
      this.techOptions = options;
      this.selectedTechOption = this.techOptions[0];
    })
    this.selectedCriteriaOption = this.criteriaOption[0];
    this.selectedAnalyse = this.analyseOptions[0];
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log("REMOTE POWER DETAILS", this.detailsData);
  }

  preventNonNumeric(evt) {
    const txt = evt.target.value;
    console.log(txt)
    // if (txt === "")
    // {
    //   evt.target.value = 0;
    // }
  }

  calcSumConsumption(formObj) {
    return (
      Number(formObj.shareCheapestSystem) +
      Number(formObj.shareCheapetHeat4Consumer) +
      Number(formObj.shareLowestCo2Emissions) +
      Number(formObj.shareMinConsumtionBasicEnergy) +
      Number(formObj.shareMaxOVEShare)
    );
  }
  maxConsumtionLogic() {
    if (this.sumConsumption > 100) {
      this.remotePowerDetailsForm.controls['shareCheapestSystem'].setValue(this.shareCheapestSystemMAX, { emitEvent: false });
      this.remotePowerDetailsForm.controls['shareCheapetHeat4Consumer'].setValue(this.shareCheapetHeat4ConsumerMAX, { emitEvent: false });
      this.remotePowerDetailsForm.controls['shareLowestCo2Emissions'].setValue(this.shareLowestCo2EmissionsMAX, { emitEvent: false });
      this.remotePowerDetailsForm.controls['shareMinConsumtionBasicEnergy'].setValue(this.shareMinConsumtionBasicEnergyMAX, { emitEvent: false });
      this.remotePowerDetailsForm.controls['shareMaxOVEShare'].setValue(this.shareMaxOVEShareMAX, { emitEvent: false });
    }
    else {
      this.lastValue();
    }
  }

  lastValue() {
    this.shareCheapestSystemMAX = this.remotePowerDetailsForm.controls['shareCheapestSystem'].value;
    this.shareCheapetHeat4ConsumerMAX = this.remotePowerDetailsForm.controls['shareCheapetHeat4Consumer'].value;
    this.shareLowestCo2EmissionsMAX = this.remotePowerDetailsForm.controls['shareLowestCo2Emissions'].value;
    this.shareMinConsumtionBasicEnergyMAX = this.remotePowerDetailsForm.controls['shareMinConsumtionBasicEnergy'].value;
    this.shareMaxOVEShareMAX = this.remotePowerDetailsForm.controls['shareMaxOVEShare'].value;
  }

  onAnalyseSelectClick(event) {
    this.selected = true;
    this.selectedAnalyse = event;
    if (event.id === 1) {
      this.selectedTechOptionId = 1;
      this.selectedCriteriaOptionId = 0;
    }
    if (event.id === 2) {
      this.selectedCriteriaOptionId = 1;
      this.selectedTechOptionId = 0;
    }
    // console.log("EVENT", event)
  }

  onTechSelectClick(event) {
    this.selectedTechOption = event;
    this.selectedTechOptionId = event.id
    this.selectedCriteriaOptionId = 0;
  }



  onCriteriaSelectClick(event): void {
    this.selectedCriteriaOption = event;
    this.selectedCriteriaOptionId = event.id;
    this.selectedTechOptionId = 0;
  }

  onSubmit(): void {
    if (this.selectedAnalyse.id === null) return
    const idObmocja = this.detailsData._id_obmocja.replaceAll('.', '')
    // let techId = this.selectedTechOptionId
    // if(this.selectedAnalyse.id !== 1) techId = 0;

    const payload: IRemotePowerDetails = {
      areaId: Number(idObmocja),
      analysisTypeId: this.selectedAnalyse.id,
      technologyId: this.selectedTechOptionId,
      sortById: this.selectedCriteriaOptionId,
      
    };
    if(this.selectedAnalyse.id === 3){
      payload.shareCheapestSystem =  this.shareCheapestSystemMAX,
      payload.shareCheapetHeat4Consumer = this.shareCheapetHeat4ConsumerMAX,
      payload.shareLowestCo2Emissions = this.shareLowestCo2EmissionsMAX,
      payload.shareMinConsumtionBasicEnergy = this.shareMinConsumtionBasicEnergyMAX,
      payload.shareMaxOVEShare =  this.shareMaxOVEShareMAX
    }

    console.warn(payload)
    this.isLoading = true;
    this.messageService.add({ key: 'remotePowerDetails', severity: 'info', summary: 'Obvestilo', detail: 'Analiza je v teku ...' });
    const interval = setInterval(() => {
      if(this.progressValue == 100) return this.progressValue = 0;
      this.progressValue++;
      this.progressValue++;
      this.progressValue++;
    }, 500)
    this.remotePowerService.postRemotePowerDetailsResults(payload).subscribe(
      {
        next: response => {
          console.warn("RESPONSE DETAILS", response)
          this.messageService.add({ key: 'remotePowerDetails', severity: 'info', summary: 'Obvestilo', detail: 'Analiza je zaključena' });
          clearInterval(interval);
          this.isLoading = false;
          this.analyseEmmiter.emit({ response: response, payload: payload });
          // this.remotePowerService.emitOpenDteailsTable(response)
        },
        error: err => {
          this.analyseErrorEmiter.emit({ response: { msg: "Poizvedba ni vrnila rezultatov!" } });
          this.isLoading = false;

          // console.error("Error", err)
        }
      }
    )
  }
}
